import { string } from '@/shared/libs/yup';
import { HookFormField, FieldArrayProps } from '@/shared/libs/hook-form';
import { array, object } from '@/shared/libs/yup';

export const domainsSchema = array().of(object({
    value: string().domain('Invalid email domain').required().uniqueArrayItem().label('Company Email Domain'),
  })).label('Domains');

export const DomainsField = (props: FieldArrayProps) => <HookFormField.Array label="Domains" addLabel="Add domain" {...props}/>;
